/** Lightweight shimmer placeholder while CAD read models hydrate. */
export function SurfaceSkeleton({ rows = 3, label = "Loading" }: { rows?: number; label?: string }) {
  return (
    <div className="surface-skeleton" role="status" aria-label={label}>
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="surface-skeleton__row" />
      ))}
    </div>
  );
}
